/**
 * Aurié Luxe Co. — Product section JS
 * assets/aurie-product.js
 *
 * Load deferred at bottom of theme.liquid or via section render:
 *   <script src="{{ 'aurie-product.js' | asset_url }}" defer></script>
 *
 * No external dependencies — vanilla JS only.
 */

(function () {
  'use strict';

  /* ── Gallery ─────────────────────────────────────────────── */
  function initGallery(section) {
    const thumbs  = section.querySelectorAll('[data-thumb]');
    const slides  = section.querySelectorAll('[data-slide]');

    if (!thumbs.length || !slides.length) return;

    function goTo(index) {
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      slides.forEach(function (s) { s.classList.remove('is-active'); });
      const thumb = section.querySelector('[data-thumb="' + index + '"]');
      const slide = section.querySelector('[data-slide="' + index + '"]');
      if (thumb) thumb.classList.add('is-active');
      if (slide) slide.classList.add('is-active');
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        goTo(Number(thumb.dataset.thumb));
      });
    });
  }

  /* ── Quantity stepper ────────────────────────────────────── */
  function initQty(section) {
    const input = section.querySelector('[data-qty-input]');
    const dec   = section.querySelector('[data-qty-dec]');
    const inc   = section.querySelector('[data-qty-inc]');

    if (!input || !dec || !inc) return;

    dec.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      if (v > 1) input.value = v - 1;
    });

    inc.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = v + 1;
    });

    input.addEventListener('change', function () {
      var v = parseInt(input.value, 10);
      if (isNaN(v) || v < 1) input.value = 1;
    });
  }

  /* ── Add-to-Cart (AJAX) ──────────────────────────────────── */
  function initATC(section) {
    var form   = section.querySelector('#aurie-add-to-cart-form');
    var btn    = section.querySelector('[data-atc-btn]');

    if (!form || !btn) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (btn.disabled) return;

      var formData = new FormData(form);
      var body     = JSON.stringify({
        id:       formData.get('id'),
        quantity: parseInt(formData.get('quantity'), 10) || 1,
      });

      btn.disabled = true;
      var originalText = btn.textContent.trim();
      btn.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body:    body,
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Cart error');
          return res.json();
        })
        .then(function () {
          btn.classList.add('is-added');
          btn.textContent = 'Added to Cart ✓';

          // Update cart count bubble if the theme exposes one
          document.dispatchEvent(new CustomEvent('cart:refresh'));

          setTimeout(function () {
            btn.classList.remove('is-added');
            btn.textContent = originalText;
            btn.disabled = false;
          }, 2200);
        })
        .catch(function () {
          btn.textContent = 'Error — try again';
          btn.disabled = false;
          setTimeout(function () { btn.textContent = originalText; }, 2200);
        });
    });
  }

  /* ── Variant picker ──────────────────────────────────────── */
  function initVariants(section) {
    var variantInputs = section.querySelectorAll('.aurie-variant-option input[type="radio"]');
    var idInput       = section.querySelector('input[name="id"]');
    var priceEl       = section.querySelector('.aurie-product__price');
    var atcBtn        = section.querySelector('[data-atc-btn]');

    if (!variantInputs.length || !idInput) return;

    // Shopify exposes `window.ShopifyAnalytics` and the product JSON via a
    // script tag rendered in the JSON template (see aurie-product.json).
    var productJson = window.__aurieProduct;
    if (!productJson) return;

    function getSelectedOptions() {
      var opts = {};
      variantInputs.forEach(function (input) {
        if (input.checked) opts[input.name] = input.value;
      });
      return opts;
    }

    function findVariant(selectedOpts) {
      return productJson.variants.find(function (v) {
        return v.options.every(function (opt, i) {
          var key = productJson.options[i];
          return selectedOpts[key] === opt;
        });
      });
    }

    variantInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        var opts    = getSelectedOptions();
        var variant = findVariant(opts);
        if (!variant) return;

        idInput.value = variant.id;

        if (priceEl) {
          priceEl.textContent = variant.price_formatted || (
            (variant.price / 100).toLocaleString('en-CA', { style: 'currency', currency: 'CAD' })
          );
        }

        if (atcBtn) {
          atcBtn.disabled    = !variant.available;
          atcBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
        }

        // Update browser URL without reload
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      });
    });
  }

  /* ── Boot ────────────────────────────────────────────────── */
  function init() {
    document.querySelectorAll('[data-section-id]').forEach(function (section) {
      initGallery(section);
      initQty(section);
      initATC(section);
      initVariants(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify theme editor: re-init when section is reloaded
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target;
    initGallery(section);
    initQty(section);
    initATC(section);
    initVariants(section);
  });
})();